import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import debounce from 'lodash/debounce';
import SvgIconButton from '../../../components/SvgIconButton';
import infoIcon from '../../../assets/images/info';
import closeIcon from '../../../assets/images/studio/close';
import CircularLoader from '../../../components/circularLoader/CircularLoader';
import LessonPreviewContent from '../../common/lessonInfoDialog/LessonPreviewContent';
import {isNotationXml} from '../../../utils/commonUtility';
import '../create.scss';
import '../looper/looper.scss';
import {ProjectAssetsType} from "../../../constants/enums";

const infoIconStyle = {
    width: '10px',
    height: '10px',
    minWidth: '10px',
    minHeight: '10px',
    borderRadius: 0
};

const closeIconStyle = {
    width: '16px',
    height: '16px',
    minWidth: '16px',
    minHeight: '16px',
    borderRadius: 0
};

@inject('notationViewerStore', 'looperStore', 'studioStore', 'projectStore')
@injectIntl
@observer
class NotationViewerContainer extends Component {
    // @observable soundSliceRef = null;
    ref = null;
    width = window.innerWidth;

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
        if (this.ref) {
            this.ref.removeEventListener('touchend', this.handleTouchEnd);
        }
        this.props.notationViewerStore.clear();
    }

    resize = debounce(async () => {
        if (this.width === window.innerWidth) return;
        this.width = window.innerWidth;
        if (isNotationXml(this.props.notationViewerStore.notation.type)) {
            await this.props.notationViewerStore.redraw(undefined, true);
        }
    }, 300);

    handleTouchEnd = (e) => {
        if (this.props.notationViewerStore.horizontal) {
            // todo add another test - if we are at the scroll end and we swipe right, we can allow
            e.stopPropagation();
        }
    };


    setRef = (ref) => {
        if (ref) {
            this.ref = ref;
            ref.addEventListener('touchend', this.handleTouchEnd);
        }
    };

    setCursorRef = (ref) => {
        this.props.notationViewerStore.setCursorRef(ref);
    };

    setNotationRef = (ref) => {
        this.props.notationViewerStore.setNotationRef(ref);
    }

    onClick = (e) => {
        e.preventDefault();
        return false;
    };

    removeWarningHandle = (e) => {
        e.preventDefault();
        document.querySelector('.soundslice-warning').remove();
    };

    renderMainContent = () => {
        const {file, tabType, notationViewerStore, isCanvasEditable, intl: {formatMessage: translate}, cancelCanvas} = this.props;
        if (notationViewerStore.error) {
            return <div className="library-container soundslice-container">
                <div className="notation-error">
                    Sorry, we're having a temporary technical issue<br/>
                    presenting this notation file. We're just as excited<br/>
                    as you are to get this working again, and are working<br/>
                    on getting it fixed as soon as possible.
                </div>
            </div>
        }
        if (tabType === ProjectAssetsType.Notation && notationViewerStore.xmlLoaded) {
            const {pitchChanged, stemEdited, isLoaded, cursorPosition} = notationViewerStore;
            const pitchWarning = pitchChanged ? translate({id: 'notations.transpositionWarning'}) : '';
            const stemWarning = stemEdited ? translate({id: 'notations.stemEdit'}) : '';

            let reason = '';
            if (pitchWarning && stemWarning) {
                reason = `${pitchWarning} ${translate({id: 'notations.and'})} ${stemWarning}`
            } else {
                reason = `${pitchWarning}${stemWarning}`;
            }

            const error = translate({id: 'notations.warning'}, {error: reason});

            return (
                <Fragment>
                    {((pitchChanged || stemEdited)) && <div className="soundslice-warning">
                        <SvgIconButton
                            viewBox="0 0 12 12" icon={infoIcon} buttonStyle={infoIconStyle} hoverColor="none" rippleColor="none"
                            iconStyle={infoIconStyle} containerClass="file-input-error-icon notation-viewer"/>
                        {error}
                        <SvgIconButton
                            viewBox="0 0 40 40" icon={closeIcon} buttonStyle={closeIconStyle} hoverColor="none" rippleColor="none"
                            iconStyle={closeIconStyle} containerClass="file-input-error-close" onClick={this.removeWarningHandle}/>
                    </div>}
                    <div className={`library-container soundslice-container ${notationViewerStore.horizontal ? 'horizontal-view' : ''}`} ref={this.setRef}>
                        {!isLoaded && <CircularLoader containerStyle={{position: 'fixed'}}/>}
                        {isLoaded && <div ref={this.setNotationRef} dangerouslySetInnerHTML={{__html: notationViewerStore.svg}}/>}
                        {isLoaded && <div ref={this.setCursorRef} className={`playhead-wrapper ${notationViewerStore.horizontal ? 'horizontal' : ''}`}
                                        style={{
                                            left: cursorPosition.left,
                                            top: cursorPosition.top - cursorPosition.height / 2,
                                            height: cursorPosition.height * 2
                                        }}>
                            <div className="playhead" style={{height: cursorPosition.height, width: cursorPosition.width}}/>
                        </div>}
                        {(this.props.looperStore.isLooperPlaying && this.props.looperStore.countDownValue > 0) &&
                        <div className={`countdown ${notationViewerStore.horizontal ? 'horizontal' : ''}`}
                            style={{left: cursorPosition.left, top: cursorPosition.top}}>
                            {this.props.looperStore.countDownValue}
                        </div>
                        }

                    </div>
                </Fragment>
            );
        } else {
            return (<LessonPreviewContent file={file} isCanvasEditable={isCanvasEditable} cancelCanvas={cancelCanvas}/>);
        }
    }


    render() {
        const {file, isCanvasEditable} = this.props;
        if (!file) {
            return null;
        }
        return (
            <Fragment>
                <div className="preview-dialog-container">
                    <div className={`preview-body preview-body-scrollable ${isCanvasEditable ? 'is-editable' : ''}`}>
                        {this.renderMainContent()}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default NotationViewerContainer;
